import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer'
import SurveyGridHeader from '../components/GridComponents/SurveyGridHeader';
import SurveyGridBody from '../components/GridComponents/SurveyGridBody';
import SurveyGridRow from '../components/GridComponents/SurveyGridRow';
import {
    CommonResponses,
    ElementType,
    SelectCombos,
} from '../Enums/constants';
import SurveyConditionalSegment from "../components/SurveyConditionalSegment";

export const PabsLgCustomerExperienceTab = () => {
    return (
        <SurveyPage>
            <SurveyTitleArea pageName="Customer Experience" />
            <SurveyContentContainer>
                <SurveySection labelText="Member Experience Surveying">
                    <SurveyElement
                        questionNumber="83"
                        labelText="Did you send any satisfaction or member experience surveys in your most recent fiscal year?"
                        name="GenSurvyn"
                        inputType={ElementType.SELECT}
                        options={SelectCombos.YES_NO}
                    />
                    <SurveyConditionalSegment
                        showIf={{
                            GenSurvyn: { not: CommonResponses.NO }
                        }}
                    >
                        <SurveyElement
                            questionNumber="83.a"
                            labelText="Did you survey a sample of the following customer groups:"
                            subQuestion
                        />
                        <SurveyElement
                            questionNumber="83.a.a1"
                            labelText="Active members"
                            name="GenSurvActives"
                            inputType={ElementType.SELECT}
                            options={SelectCombos.YES_NO}
                            doubleSubQuestion
                        />
                        <SurveyElement
                            questionNumber="83.a.a2"
                            labelText="Annuitants"
                            name="GenSurvAnn"
                            inputType={ElementType.SELECT}
                            options={SelectCombos.YES_NO}
                            doubleSubQuestion
                        />
                        <SurveyElement
                            questionNumber="83.a.a3"
                            labelText="Inactive members"
                            name="GenSurvInactives"
                            inputType={ElementType.SELECT}
                            options={SelectCombos.YES_NO}
                            doubleSubQuestion
                        />
                        <SurveyElement
                            questionNumber="83.b"
                            labelText="Did you send a survey focused on a sample of members that recently engaged with your plan?"
                            name="ActivitySurvyn"
                            inputType={ElementType.SELECT}
                            options={SelectCombos.YES_NO}
                            subQuestion
                        />
                        <SurveyConditionalSegment
                            showIf={{
                                ActivitySurvyn: { not: CommonResponses.NO }
                            }}
                        >
                            <SurveyElement
                                inputType="grid"
                                styleName={"dataTable pabsCostTable"}
                            >
                                <SurveyGridHeader>
                                    <SurveyElement
                                        labelText=""
                                        inputType={ElementType.LABEL} />
                                    <SurveyElement
                                        labelText="Satisfaction or NPS"
                                        inputType={ElementType.LABEL} />
                                    <SurveyElement
                                        labelText="Effort (CES)"
                                        inputType={ElementType.LABEL}
                                    />
                                </SurveyGridHeader>
                                <SurveyGridBody>
                                    <SurveyGridRow>
                                        <SurveyElement questionNumber="83.b.b1"
                                            labelText="Calls"
                                            inputType={ElementType.LABEL}
                                            subQuestion
                                        />
                                        <SurveyElement
                                            name="SatSurvNPSCalls"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                        <SurveyElement
                                            name="CESCalls"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                    </SurveyGridRow>
                                    <SurveyGridRow>
                                        <SurveyElement questionNumber="83.b.b2"
                                            labelText="Self-service website"
                                            inputType={ElementType.LABEL}
                                            subQuestion
                                        />
                                        <SurveyElement
                                            name="SatSurvNPSWebsite"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                        <SurveyElement
                                            name="CESWebsite"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                    </SurveyGridRow>
                                    <SurveyGridRow>
                                        <SurveyElement questionNumber="83.b.b3"
                                            labelText="1-on-1 counseling"
                                            inputType={ElementType.LABEL}
                                            subQuestion
                                        />
                                        <SurveyElement
                                            name="SatSurvNPS1on1"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                        <SurveyElement
                                            name="CES1on1Counseling"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                    </SurveyGridRow>
                                    <SurveyGridRow>
                                        <SurveyElement questionNumber="83.b.b4"
                                            labelText="Member presentations"
                                            inputType={ElementType.LABEL}
                                            subQuestion
                                        />
                                        <SurveyElement
                                            name="SatSurvNPSPresentations"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                        <SurveyElement
                                            name="CESPresentations"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                    </SurveyGridRow>
                                    <SurveyGridRow>
                                        <SurveyElement questionNumber="83.b.b5"
                                            labelText="New member enrollment"
                                            inputType={ElementType.LABEL}
                                            subQuestion
                                        />
                                        <SurveyElement
                                            name="SatSurvNPSNewjob"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                        <SurveyElement
                                            name="CESNewActive"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                    </SurveyGridRow>
                                    <SurveyGridRow>
                                        <SurveyElement questionNumber="83.b.b6"
                                            labelText="Leaving the pension plan"
                                            inputType={ElementType.LABEL}
                                            subQuestion
                                        />
                                        <SurveyElement
                                            name="SatSurvNPSExitPlan"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                        <SurveyElement
                                            name="CESExitPlan"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                    </SurveyGridRow>
                                    <SurveyGridRow>
                                        <SurveyElement questionNumber="83.b.b7"
                                            labelText="Disability"
                                            inputType={ElementType.LABEL}
                                            subQuestion
                                        />
                                        <SurveyElement
                                            name="SatSurvNPSDisability"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                        <SurveyElement
                                            name="CESDisability"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                    </SurveyGridRow>
                                    <SurveyGridRow>
                                        <SurveyElement questionNumber="83.b.b8"
                                            labelText="Retirement experience"
                                            inputType={ElementType.LABEL}
                                            subQuestion
                                        />
                                        <SurveyElement
                                            name="SatSurvNPSRetire"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                        <SurveyElement
                                            name="CESRetire"
                                            inputType={ElementType.SELECT}
                                            options={SelectCombos.YES}
                                        />
                                    </SurveyGridRow>
                                </SurveyGridBody>
                            </SurveyElement>
                        </SurveyConditionalSegment>
                    </SurveyConditionalSegment>
                </SurveySection>
            </SurveyContentContainer>
        </SurveyPage>
    )
}